import React, { useState, useEffect, useCallback } from 'react'
import { useSnackbar } from 'notistack'
import DynamicTable from '../../components/DataTables/DynamicTable'
import ConfiguracionLogic from '../../functions/logic/Configuracion'
import SeguridadesLogic from '../../functions/logic/Seguridades'
import Spiner from '../../components/General/Spiner'
import FormModal from '../../components/General/FormModal'
import { styled } from '@mui/material/styles'
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const Usuarios = () => {
  const [spiner, setSpiner] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [data, setdata] = useState([])
  const [totalRows, setTotalRows] = useState(0)
  const [originalData, setOriginalData] = useState([]);
  const [isOpenModalform, setIsOpenModalForm] = useState(false)
  const [dataUsuariosForm, setDataUsuariosForm] = useState([])
  const [saveType, setSaveType] = useState('I')
  const [header, setHeader] = useState('I')
  const [empresaId, setEmpresaId] = useState(0)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [dataTableroForm, setDataTableroForm] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null)
  const [authType, setAuthType] = useState("I")
  const [columns, setColumns] = useState([])

  const getUsuarios = useCallback(async (idUsuario, page, perPage, search = "", tipo) => {
    setSpiner(true)
    const columnsV = ['Identificación', 'Código', 'Nombre', 'Email', 'Nacimiento','Estado']
    setColumns(columnsV)
    const resp = await ConfiguracionLogic.usuariosConfigLogic(idUsuario, page, perPage, search, tipo)
    const rolResp = await SeguridadesLogic.rolesLogic(page, 1000, search)
    localStorage.setItem('rolResp', JSON.stringify(rolResp.data))
    if (resp.success) {
      setdata(resp.data)
      setTotalRows(resp.totalRows)
    }
    enqueueSnackbar(resp.message, {
      variant: resp.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })
    setAuthType("E")
    cleanStorage()
    setSpiner(false)
  }, [enqueueSnackbar]);

  const getColorForRol = (rol) => {
    switch (rol.toLowerCase()) {
      case "tableros":
        return "lightblue";
      case "seguridades":
        return "lightcoral";
      case "ventas":
        return "lightgreen";
      default:
        return "lightgray";
    }
  };

  const getUsuariosI = async (page, perPage, filroBusqueda) => {
    setSpiner(true)
    const resp = await SeguridadesLogic.usuariosLogic(page, perPage, "I", filroBusqueda);

    if (resp.success) {
      const formatearUsuario = (usuario) => {
        return usuario.toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
      };

      const dataFormateada = resp.data.map((usuarioObj) => ({
        ...usuarioObj,
        Usuarios: formatearUsuario(usuarioObj.Usuarios),
      }));

      setOriginalData(dataFormateada);
      setdata(dataFormateada);
      setTotalRows(resp.totalRows);
    }

    const columnsV = ['Correo', 'Rol', 'Estado', 'Usuarios']
    setColumns(columnsV)
    enqueueSnackbar(resp.message, {
      variant: resp.variant,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
    setAuthType("I")
    setSpiner(false);
  }

  useEffect(() => {
    //getUsuarios(0, 1, 10, '', 'E')
    getUsuariosI(1, 10, '')
  }, [getUsuarios])

  const handleAuthTypeChange = (e) => {
    e.target.value === "E"
      ? getUsuarios(0, 1, 10, '', e.target.value)
      : getUsuariosI(1, 10, '')
  } // Ajusta esto según tus necesidades

  const handlePageChange = (page, perPage) => {
    if (authType === "E") {
      getUsuarios(0, page, perPage, '')
    } else {
      getUsuariosI(page, perPage, '')
    }
  }

  const handleSearch = (item) => {
    if (authType === "E") {
      getUsuarios(0, 1, 10, item)
    } else {
      getUsuariosI(1, 10, item)
    }
  }

  const handleEdit = async (item) => {
    if (authType === "E") {
      cleanStorage()
      setSpiner(true)
      const resp = await ConfiguracionLogic.usuariosConfigLogic(item.id, 1, 10, '')
      setSaveType("E")
      setEmpresaId(item.id)
      setDataUsuariosForm(resp)
      setIsOpenModalForm(true)
      setSpiner(false)
      setHeader('Editar Usuarios')
    } else {
      setSpiner(true);
      const resp = await SeguridadesLogic.usuariosByIdLogic(item.id);
      cleanStorage();
      setSaveType("E");
      //setUsuarioId(item.id);
      setSpiner(true);
      setDataTableroForm(resp);
      setIsOpenModalForm(true);
      setSpiner(false);
      setHeader("Usuario");
    }
  }

  // Funciones para manejar las acciones de los botones
  const handleNew = async () => {
    cleanStorage()
    setSaveType("I")
    setEmpresaId(0)
    setSpiner(true)
    setDataUsuariosForm([])
    setIsOpenModalForm(true)
    setSpiner(false)
    setHeader('Nuevo Usuario')
  }

  const cleanStorage = () => {
    localStorage.removeItem("userNumIden");
    localStorage.removeItem("userPNombre");
    localStorage.removeItem("userSNombre");
    localStorage.removeItem("userPApellido");
    localStorage.removeItem("userSApellido");
    localStorage.removeItem("UserCodUser");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userSexo");
    localStorage.removeItem("userFNaci");
    localStorage.removeItem("userActi");
    localStorage.removeItem("userEmpId");
  }

  const handleDelete = (item) => {

    console.log("------> item hanlder eliminar " , item );
    setSelectedItem(item)
    setOpenDeleteModal(true)
  }

  const confirmDelete = async () => {
    if (selectedItem) {
      setSpiner(true)
      const resp = await ConfiguracionLogic.usuariosSeguridadesBiLogic(selectedItem.id, selectedItem, "D")
      enqueueSnackbar(resp.message, {
        variant: resp.variant,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      })
      if (resp.success) {
        window.location.reload()
      }
      setSpiner(false)
      setOpenDeleteModal(false)
    }
  }

  const cancelDelete = () => {
    setOpenDeleteModal(false)
  }

  const handleCloseModal = () => {
    setIsOpenModalForm(false)
    cleanStorage()
  }

  const handledSave = async (event) => {
    event.preventDefault()
    setSpiner(true)
    let resp
    if (authType === "E") {
      resp = await ConfiguracionLogic.usuariosSeguridadesRolExtLogic(empresaId, event.target, saveType)
      console.log("eNTRA POR ACA " ,event.target );
    } else {
      resp = await ConfiguracionLogic.usuariosSeguridadesRolIntLogic(empresaId, event.target, saveType)
      //resp = await ConfiguracionLogic.usuariosSeguridadesRolIntLogic(empresaId, event.target, saveType)
    }
    enqueueSnackbar(resp.message, {
      variant: resp.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })
    setSpiner(false)
    if (authType === "E") {
      if (saveType === 'I') {
        if (resp.success) {
          setIsOpenModalForm(false)
          cleanStorage()
        }
        setTimeout(function () {
          if (resp.success) {
            window.location = global.USUARIOS_CREATE
          }
        }, global.DELAY)
      } else {
        cleanStorage()
        const resp = await ConfiguracionLogic.usuariosConfigLogic(empresaId, 1, 10, '')
        setDataUsuariosForm(resp)
        if (resp.success) {
          window.location.reload()
        }
      }
    }
  }

  const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: '20px',
    marginLeft: theme.spacing(4),
    padding: theme.spacing(1, 4),
  }))

  return (

    <div className="content-wrapper" >
      <Spiner opt={spiner} />
      <FormModal
        isOpen={isOpenModalform}
        handleCloseModal={handleCloseModal}
        header={header}
        button={'Guardar'}
        handledSave={handledSave}
        editRoles={authType === "E" ? "usuariosConfig" : "usuarios"}
        formData={authType === "E" ? dataUsuariosForm : dataTableroForm}
        opt={authType === "E" ? "usuariosConfig" : "usuarios"}
        modalWith={'md'} // Puedes ajustar a 'xs', 'sm', 'lg', 'xl' según lo que necesites
      />
      <section className="content-header" style={{ padding: '0px' }}>
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">Configuración</li>
                <li className="breadcrumb-item">Usuarios</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content" style={{ padding: '0px' }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-2">
              <div className="form-group">
                <label htmlFor="authType" className="label-left">
                  Tipo de Usuario:
                </label>
                <select
                  id="authType"
                  name="authType"
                  value={authType}
                  onChange={handleAuthTypeChange}
                  className="custom-select"
                >
                  <option value="I">Interno</option>
                  <option value="E">Externo</option>
                </select>
              </div>
            </div>
            <div className="col-12">
              <div className="card">
                <br />
                <div className="card-body">
                  {
                    authType === "I"
                      ?
                      <DynamicTable
                        columns={columns}
                        data={data.map((item) => ({
                          ...item,
                          Usuarios: (
                            <div>
                              <strong>{item.Usuarios}</strong>
                              <br />
                              <span style={{ fontSize: "smaller", color: "gray" }}>
                                {item.Correo}
                              </span>
                            </div>
                          ),
                          Rol: (
                            <div>
                              {item.Rol.map((rol, index) => (
                                <span
                                  key={index}
                                  style={{
                                    backgroundColor: getColorForRol(rol),
                                    padding: "5px",
                                    borderRadius: "5px",
                                    marginRight: "5px",
                                    display: "inline-block",
                                  }}
                                >
                                  {rol}
                                </span>
                              ))}
                            </div>
                          ),
                        }))}
                        onNew={handleNew}
                        onEditPHX={handleEdit}
                        onSearch={handleSearch}
                        onPageChange={handlePageChange}
                        totalRows={totalRows}
                      />
                      :
                      <DynamicTable
                        columns={columns}
                        data={data}
                        onNew={handleNew}
                        headerText="Nuevo Usuario"
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        onSearch={handleSearch}
                        onPageChange={handlePageChange}
                        totalRows={totalRows}
                      />
                  }

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Dialog
        open={openDeleteModal}
        onClose={cancelDelete}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialogContent-root": {
            overflowY: "hidden", // Esto evitará la barra de desplazamiento
          },
          "& .MuiDialog-paper": {
            maxHeight: "400px", // Ajusta el tamaño máximo del modal si es necesario
          },
        }}
      >
        <DialogTitle>
          Confirmar Eliminación
          <IconButton
            edge="end"
            color="inherit"
            onClick={cancelDelete}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <p>¿Estás seguro que deseas eliminar este elemento?</p>
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={cancelDelete} sx={{ backgroundColor: 'lightblue', color: 'blue', '&:hover': { backgroundColor: 'lightblue' } }}>
            Cancelar
          </StyledButton>
          <StyledButton onClick={confirmDelete} sx={{ backgroundColor: 'blue', color: 'white', '&:hover': { backgroundColor: 'darkblue' } }}>
            Confirmar
          </StyledButton>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default Usuarios
